import { Stack } from 'components';
import { ReactNode, useState } from 'react';

import style from './footer.module.scss';
import { FooterProvider, useFooterContext } from './FooterContext';
import { Description, History, Item, PersonInfo } from './history';

type Props = {
  children: ReactNode;
};

const ExpandHistoryButton = () => {
  const { historyOpen, setHistoryOpen } = useFooterContext();

  return (
    <button
      type="button"
      onClick={() => setHistoryOpen((prev) => !prev)}
      className={style.historyButton}
    >
      <span className="material-icons" data-open={historyOpen}>
        keyboard_arrow_down
      </span>
      History
    </button>
  );
};

const FooterActions = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      pt="12px"
      borderTop="1px solid #F1F5F9"
    >
      {children}
    </Stack>
  );
};

const Footer = ({ children }: Props) => {
  const [historyOpen, setHistoryOpen] = useState(false);

  return (
    <FooterProvider value={{ historyOpen, setHistoryOpen }}>
      <Stack display="flex" gap="12px">
        {children}
      </Stack>
    </FooterProvider>
  );
};

export { ExpandHistoryButton, FooterActions, History, Item, Description, PersonInfo };

export default Footer;
